import React, { useEffect, useState, createContext, useContext } from "react";
import axios from "axios";

export const ConnectionContext = createContext(null);

export const ConnectionProvider = ({ children }) => {
    const [hasConnection, setHasConnection] = useState(true);
    const [isCheckingConnection, setIsCheckingConnection] = useState(true);

    useEffect(() => {
        const checkConnection = async () => {
            try {
                // Ping backend warmup endpoint to verify connection
                await axios.get("health", { timeout: 5000 });
                setHasConnection(true);
            } catch (error) {
                console.error("Connection check failed:", error);
                setHasConnection(false);
            } finally {
                setIsCheckingConnection(false);
            }
        };

        checkConnection();
    }, []);

    return (
        <ConnectionContext.Provider
            value={{ hasConnection, isCheckingConnection }}
        >
            {children}
        </ConnectionContext.Provider>
    );
};

// Custom hook to use connection context
export const useConnection = () => {
    return useContext(ConnectionContext);
};
